import React, { useState, useEffect } from "react";
import { XIcon } from "@heroicons/react/outline";
import { ArrowLeftIcon } from "@heroicons/react/solid";
import Dialog from "@/ui/Dialog";
import { IconButton } from "@/ui/IconButton";
import PurpleDoorLogoHorizontal from "../Logo/PurpleDoorLogoHorizontal";
import Button from "@/ui/Button";

import { useAuth } from "@/lib/auth";
import { readDocument } from "@/lib/db";

import SignUpSignIn from "../user/SignUpSignIn";
import { isSignedIn } from "@/components/user/UserUtils";

// Import all help option components
//import SearchCommunityHelp from "./options/SearchCommunityHelp";
import UnderstandingRequirementsHelp from "./options/UnderstandingRequirementsHelp";
//import LowIncomeHousingHelp from "./options/LowIncomeHousingHelp";
//import CaseworkerReferralHelp from "./options/CaseworkerReferralHelp";
import CommunitySignupHelp from "./options/CommunitySignupHelp";
import AskQuestionHelp from "./options/AskQuestionHelp";
//import JobInquiryHelp from "./options/JobInquiryHelp";
import CreateAccountHelp from "./options/CreateAccountHelp";

const HelpDialog = ({ open, setOpen }) => {
    const auth = useAuth();
    const [selectedOption, setSelectedOption] = useState(null);
    const [user, setUser] = useState({});
    const [openSignUp, setOpenSignUp] = useState(false);
    const [openSignIn, setOpenSignIn] = useState(false);

    const userId = auth.user ? auth.user.uid : "";

    useEffect(() => {
        const getUser = async (uid) => {
            const user = await readDocument("users", uid);
            setUser(user);
        };

        if (userId) {
            getUser(userId);
        }
    }, [userId]);

    const handleClose = () => {
        setOpen(false);
        setSelectedOption(null);
    };

    const handleBack = () => {
        setSelectedOption(null);
    };

    const helpOptions = [
        { id: 1, text: "Get Started - It's Free", component: CreateAccountHelp },
        { id: 2, text: "Get The Free Tour Guide", link: "/pdf/PD_Tour_Questionnaire.pdf" },
        {
            id: 3,
            text: "Helpful Resources",
            link: "/resources",
        },
        { id: 4, text: "Get in Touch", component: AskQuestionHelp },
        //{ id: 3, text: "Low-Income Housing Assistance", component: LowIncomeHousingHelp },
        /*{
            id: 4,
            text: "Caseworker with a Patient Referral",
            component: CaseworkerReferralHelp,
        },*/
        //{ id: 7, text: "Job inquiry with a community", component: JobInquiryHelp },
    ];

    const SelectedComponent = selectedOption
        ? helpOptions.find((opt) => opt.id === selectedOption)?.component
        : null;

    return (
        <div>
            <Dialog
                open={open}
                className="fixed inset-0 z-50 overflow-y-auto"
                onClose={handleClose}
            >
                <div className="min-h-screen px-4 text-center">
                    <Dialog.Overlay className="fixed -z-10 inset-0 bg-black opacity-70" />

                    <span className="inline-block h-screen align-middle" aria-hidden="true">
                        &#8203;
                    </span>

                    <div
                        className={`inline-block w-full max-w-lg pb-8 overflow-hidden
                                text-left align-middle transition-all transform 
                                bg-white shadow-xl rounded-2xl`}
                    >
                        <Dialog.Title className="px-4 py-2 flex justify-between items-center bg-primary-500">
                            <div className="flex justify-center flex-grow items-center space-x-4">
                                <h3 className="text-lg sm:text-xl font-bold font-headline text-white">
                                    Finding Senior Living, made easy!
                                </h3>
                            </div>
                            <IconButton onClick={handleClose}>
                                <XIcon className="w-8 h-8 p-1 text-white hover:bg-primary-400 rounded-full" />
                            </IconButton>
                        </Dialog.Title>

                        <div>
                            {selectedOption ? (
                                <div className="px-8 pt-6 flex flex-col gap-4">
                                    {SelectedComponent && <SelectedComponent />}

                                    <div className="flex">
                                        <Button
                                            onClick={handleBack}
                                            className="flex items-center bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded-lg"
                                        >
                                            <ArrowLeftIcon className="w-4 h-4 mr-2" /> Back
                                            to options
                                        </Button>
                                    </div>
                                </div>
                            ) : (
                                <div className="px-8 pb-6">
                                    <div className="flex justify-center mt-4 scale-90">
                                        <PurpleDoorLogoHorizontal />
                                    </div>

                                    <h4 className="flex justify-center text-xl font-semibold my-6">
                                        We’re here to support you.
                                    </h4>

                                    <div className="flex flex-col space-y-3">
                                        {!isSignedIn(auth, true) && (
                                            <button
                                                size="lg"
                                                onClick={() => {
                                                    handleClose();
                                                    setOpenSignUp(true);
                                                }}
                                                className={`w-full text-center text-white px-4 py-3 rounded-lg bg-green-600 hover:bg-green-700"`}
                                            >
                                                Get Started - It's Free
                                            </button>
                                        )}

                                        <a
                                            size="lg"
                                            className={`w-full text-center text-white px-4 py-3 rounded-lg bg-primary-500 hover:bg-primary-800`}
                                            href="/pdf/PD_Tour_Questionnaire.pdf"
                                        >
                                            Get The Free Tour Guide
                                        </a>

                                        <a
                                            size="lg"
                                            className={`w-full text-center text-white px-4 py-3 rounded-lg bg-primary-500 hover:bg-primary-800`}
                                            href="/resources"
                                        >
                                            Helpful Resources
                                        </a>

                                        <button
                                            size="lg"
                                            onClick={() => setSelectedOption(4)}
                                            className={`w-full text-center text-white px-4 py-3 rounded-lg bg-primary-500 hover:bg-primary-800`}
                                        >
                                            Get in Touch
                                        </button>

                                        {/*helpOptions
                                            .filter((option) => {
                                                if (isSignedIn(auth, true)) {
                                                    return option.id !== 1;
                                                } else {
                                                    return true;
                                                }
                                            })
                                            .map((option) =>
                                                option.link ? (
                                                    <a
                                                        size="lg"
                                                        key={option.id}
                                                        onClick={() =>
                                                            setSelectedOption(option.id)
                                                        }
                                                        className={`w-full text-center text-white px-4 py-3 rounded-lg ${
                                                            option.id === 1
                                                                ? "bg-green-600 hover:bg-green-700"
                                                                : "bg-primary-500 hover:bg-primary-800"
                                                        }`}
                                                        href={option.link}
                                                    >
                                                        {option.text}
                                                    </a>
                                                ) : (
                                                    <button
                                                        size="lg"
                                                        key={option.id}
                                                        onClick={() =>
                                                            setSelectedOption(option.id)
                                                        }
                                                        className={`w-full text-center text-white px-4 py-3 rounded-lg ${
                                                            option.id === 1
                                                                ? "bg-green-600 hover:bg-green-700"
                                                                : "bg-primary-500 hover:bg-primary-800"
                                                        }`}
                                                    >
                                                        {option.text}
                                                    </button>
                                                )
                                            )*/}

                                        <div className="border-t border-gray-200 pt-3">
                                            <button
                                                onClick={handleClose}
                                                className="w-full text-base text-center text-white bg-primary-500 hover:bg-primary-800 px-4 py-3 rounded-lg"
                                            >
                                                Continue Exploring
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Dialog>

            <SignUpSignIn
                openSignUp={openSignUp}
                openSignIn={openSignIn}
                setOpenSignUp={setOpenSignUp}
                setOpenSignIn={setOpenSignIn}
            />
        </div>
    );
};

export default HelpDialog;
